import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({ name: 'transformCmsUrl' })
export class TransformCmsUrlPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) {
      return value;
    }
    value = value.replace('https://cms-dev.nv.at', '');
    value = value.replace('https://cms.nv.at', '');
    value = value.replace('https://cms-release.nv.at', '');
    return value.replace('/wp-content/uploads/', environment.staticServer + '/');
  }
}
